import { useMemo } from 'react';
import { useLocation } from 'react-router';
import { BankType, BrandType } from '../../generated/graphql';

export function parseBankString(bankString: string | null): BankType | undefined {
  if (!bankString) return undefined;

  switch (bankString.toLowerCase()) {
    case 'davivienda':
    case 'daviplata':
      return BankType.BancoDavivienda;
    default: {
      const banks = Object.values(BankType) as string[];
      const validBank = banks.includes(bankString);
      return validBank
        ? bankString as BankType
        : undefined;
    }
  }
}

export function parseBrandString(brandString: string | null): BrandType | undefined {
  const value = brandString && Object.values(BrandType).includes(brandString as BrandType)
    ? brandString as BrandType
    : BrandType.Tranquiapp;

  // only return a value if the brandString is defined
  return brandString ? value : undefined;
}

export const useBrandFromQueryParam = () => {
  const { search } = useLocation();

  const brand: BrandType | undefined = useMemo(() => {
    const query = new URLSearchParams(search);
    const brandString = query.get('brand');
    return parseBrandString(brandString);
  }, [ search ]);

  return brand;
};

export const useBankFromQueryParam = () => {
  const { search } = useLocation();

  const bank: BankType | undefined = useMemo(() => {
    const query = new URLSearchParams(search);
    const bankString = query.get('bank');
    return parseBankString(bankString);
  }, [ search ]);

  return bank;
};
